/* eslint-disable no-magic-numbers */
import React, { useEffect, useState, useRef } from 'react'
import styles from './rematch-waiting.module.scss'
import Header from '@/components/header/header'
import { useNavigate, useSearchParams } from 'react-router-dom'
import MatchingSkinContainer from '@/pages/application-flow-skins/matching/matching-skin-container'
import { useSelector } from 'react-redux'
import { RootState } from '@/store'
import { useAppDispatch } from '@/store/hooks'
import { logout } from '@/store/user'
import useMatchingPresentation from '../../hooks/use-matching-presentation'

interface Props{}

const WaitingSuccess: React.FC<Props> = () => {
  const { channelValue, adChannelCode } = useSelector((state: RootState) => state.channel)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [search] = useSearchParams()
  const options:any = search.get('options')
  const resData = options && JSON.parse(decodeURIComponent(options))

  // 下载倒计时
  const [countdownTime, setCountdownTime] = useState<number>(3)
  const timer = useRef<ReturnType<typeof setTimeout>>()

  // 倒计时
  useEffect(() => {
    if (countdownTime > 0) {
      timer.current = setTimeout(() => {
        setCountdownTime(countdownTime - 1)
      }, 1000)
    } else {
      // 惠逸花授权页
      if (resData.rqResult.thirdpartyType === 5) {
        window.location.replace(`/fill-information/authorize?options=${encodeURIComponent(JSON.stringify(resData.rqResult))}&adChannelCode=${resData.adChannelCode}&isHuaWeiPhone=${resData.isHuaWeiPhone}&applyLimit=${resData.applyLimit}`)
        return
      }
      if (channelValue?.includes('fenqile')) {
        window.location.replace(`/new-fill-information?options=${encodeURIComponent(JSON.stringify(resData))}`)
        return
      }
      // 公用授权页
      window.location.replace(`/fill-information/common-authorize?options=${encodeURIComponent(JSON.stringify(resData))}`)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countdownTime])

  const handleV2Back = () => {
    // 重匹配皮肤返回仍要复用通用 Header 的 backRegister 特殊渠道语义。
    if (channelValue?.includes('backRegister')) {
      window.location.href = `/getQuota${adChannelCode ? `?adChannelCode=${adChannelCode}` : ''}`
      dispatch(logout())
      return
    }
    navigate(-1)
  }

  // ===== 新皮肤接入 =====
  // 仅按渠道模板替换重匹配等待 JSX；上方三秒计时和授权分流保留原实现与执行顺序。
  // 重匹配页可由历史状态直接恢复，Redux 未就绪时使用旧 URL 中已编码的渠道码读取展示配置。
  const presentationChannelCode = adChannelCode || resData?.adChannelCode || ''
  const v2Presentation = useMatchingPresentation(presentationChannelCode)
  if (v2Presentation === undefined) {
    return null
  }
  if (v2Presentation) {
    return <MatchingSkinContainer onBack={handleV2Back} theme={v2Presentation.theme} />
  }

  return (
    <section className={styles.authorizePage}>
      <Header />
      { adChannelCode
        && channelValue?.includes('jufu')
        ? <img className={styles.rematchGif} src={require('@imgs/jufu/rematch.gif')} />
        : <img className={styles.rematchGif} src={require('@imgs/gif/rematch.gif')} />
      }
    </section>
  )
}

export default WaitingSuccess
